export default __webpack_public_path__ + "static/media/Android_Badge.f902960a.png";